import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { Card, Button, Tooltip, notification } from "antd";
import Request from "../../../request";
import { TableComp } from "sz-react-utils";
import moment from "moment";

const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : "DD.MM.YYYY";

class FollowUpPostponeRequest extends React.Component {
    state = {
        count: 0
    }


    componentDidMount() {

    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let response = await Request.loadPostponeRequests(params);
            this.setState({ count: response.total });
            resolve(response);
        })
    }


    updateStatus = async (id, status) => {
        let response = await Request.updatePostponeRequestStatus({ id, status });
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload();
    }

    deleteRequest = async (id) => {
        let response = await Request.deletePostponeRequest({ id });
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload();
    }


    render() {
        let { count } = this.state;
        const columns = [
            {
                title: 'Sr.No',
                key: 'serialNumber',
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Follow Up Date',
                key: 'followUpDate',
                render: (text, record) => (
                    <div>{moment(record.followUpDate).format(dateFormat)}</div>
                )
            },
            {
                title: 'Postpone Reason',
                key: 'postponeReason',
                searchTextName: 'Postpone Reason',
            },
            {
                title: 'Added By',
                key: 'addedBy',
                dataIndex: "createdByUser.name",
                searchTextName: 'Added By',
            },
            {
                title: 'Status',
                key: 'status',
                filters: [{ value: 'Pending', text: 'Pending' }, { value: 'Approved', text: 'Approved' }, { value: 'Disapproved', text: 'Disapproved' }],
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    record.status === "Pending" ? (
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Tooltip title="Approve Request">
                                <Button
                                    icon="check"
                                    size="small"
                                    shape="circle"
                                    onClick={() => this.updateStatus(record._id, "Approved")}
                                />
                            </Tooltip>
                            <Tooltip title="Reject Request">
                                <Button
                                    icon="close"
                                    size="small"
                                    shape="circle"
                                    onClick={() => this.updateStatus(record._id, "Disapproved")}
                                />
                            </Tooltip>
                            <Tooltip title="Delete Request">
                                <Button
                                    icon="delete"
                                    size="small"
                                    shape="circle"
                                    onClick={() => this.deleteRequest(record._id)}
                                />
                            </Tooltip>
                        </div>
                    ) : null
                )
            }

        ];
        return (
            <PageHeaderWrapper title={`Followup Postpone Requests - ${count}`}>
                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: "50",
                            pageSizeOptions: ["10", "20", "50", "100", "1000"],
                        }}
                    />
                </Card>
            </PageHeaderWrapper >
        )
    }
}



const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
    currentUser: global.currentUser,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FollowUpPostponeRequest);